import CreateGamer from "components/Partner/CreateGamer";
import React from "react";
import { connect } from "react-redux";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";

import { Translation } from "react-i18next";
import { IoGameController } from "react-icons/io5";
import { BsPersonPlusFill } from "react-icons/bs";
import { HiUserGroup } from "react-icons/hi2";
import { LiaMoneyBillWaveAltSolid } from "react-icons/lia";

import "swiper/css";
import "swiper/css/pagination";
import MenuItem from "components/Partner/MenuItem";
import Users from "components/SuperAdmin/Users";
import CreateAdmin from "components/SuperAdmin/CreateAdmin";
import Financial from "components/SuperAdmin/Financial";

const SuperAdmin = (props) => {
  return (
    <Translation>
      {(t) => (
        <div className="p-0 m-0  md:p-3 md:m-3  bg-secondary-400/30 rounded-md">
          <Swiper
            arrow
            slidesPerView={"auto"}
            spaceBetween={10}
            pagination={{
              clickable: true,
            }}
            className="mySwiper"
          >
            {[
              {
                icon: <BsPersonPlusFill className="text-[32px]" />,
                title: t("MENU_ITEM_CREATE_ADMIN"),
                path: "/create",
              },
              {
                icon: <HiUserGroup className="text-[32px]" />,
                title: t("MENU_ITEM_USERS"),
                path: "/users",
              },
              {
                icon: <LiaMoneyBillWaveAltSolid className="text-[32px]" />,
                title: t("MENU_ITEM_FINANCIAL"),
                path: "/financial",
              },
            ].map((item, key) => (
              <SwiperSlide className="w-36 md:w-32" key={key}>
                <MenuItem
                  icon={item.icon}
                  title={item.title}
                  path={item.path}
                />
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="p-4 bg-secondary-700 mt-4 rounded-md">
            <Routes>
              <Route path="*" element={<Navigate to="/create" />} />
              <Route index path="/create" element={<CreateAdmin />} />
              <Route path="/users" element={<Users />} />
              <Route path="/financial" element={<Financial />} />
            </Routes>
          </div>
        </div>
      )}
    </Translation>
  );
};

const mapStateToProps = (state, props) => {
  const { authentication } = state;
  const { user, loggedIn } = authentication;

  return {
    user,
    loggedIn,
  };
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SuperAdmin);
